const ASYNC_STATUSES = {
	PENDING: 'pending',
	RESOLVED: 'resolved',
	REJECTED: 'rejected',
	IDLE: 'idle',
};

export default ASYNC_STATUSES;
